
import { Heart } from "lucide-react";

const FooterBrand = () => {
  return (
    <div className="text-center mb-12">
      <div className="flex items-center justify-center mb-6">
        <Heart className="h-8 w-8 text-red-500 mr-3" />
        <h2 className="text-3xl font-bold text-red-400">Biodata360</h2>
      </div>
      <p className="text-xl text-gray-300 max-w-3xl mx-auto">
        Create beautiful marriage biodatas in minutes. Personalized, professional, and perfect for finding your ideal match.
      </p>
    </div>
  );
};

export default FooterBrand;
